import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { initDwpNavigatorPanelResize } from './dwpNavigatorPanelResize';

const DWP_SCRIPT_ID = 'dwp-navigator__trigger-script';
const DWP_SCRIPT_URL = 'https://techcentral-demo-dwp.onbmc.com/dwp/navigator/script/navigator-trigger.min.js';
const RSSO_SERVER_URL = 'https://techcentral-rsso-demo.onbmc.com';
const DWP_JWT_URL = 'https://techcentral-itom-demo.onbmc.com/helixsupport/v1/generateJWT';

const DWP_SELECTORS = [
  `#${DWP_SCRIPT_ID}`,
  `script[src="${DWP_SCRIPT_URL}"]`,
  'iframe[src*="techcentral-demo-dwp.onbmc.com"]',
  'iframe[src*="/dwp/"]',
  // '#dwp-navigator__trigger-container',
  // '#dwp-navigator__trigger-button',
  '[id*="dwp-navigator"]',
  '[class*="dwp-navigator"]',
];

// const registerDwpJwtGenerator = () => {
//   if (!window.dwpNavigator?.registerJWTGenerator) {
//     return false;
//   }

//   window.dwpNavigator.registerJWTGenerator(async () => {
//     const accessToken = Cookies.get('accessToken');
//     const headers = {
//       'Content-Type': 'application/json',
//     };

//     if (accessToken) {
//       headers.Authorization = `Bearer ${accessToken}`;
//     }

//     const response = await fetch(DWP_JWT_URL, { headers });

//     if (!response.ok) {
//       const error = new Error(`JWT request failed with status ${response.status}`);
//       console.error('[DWP Navigator]', error.message);
//       throw error;
//     }

//     const data = await response.json();
//     return data.jwt;
//   });

//   return true;
// };

const removeDwpNavigatorArtifacts = () => {
  const candidates = DWP_SELECTORS.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
  const uniqueCandidates = Array.from(new Set(candidates));

  uniqueCandidates.forEach((node) => {
    if (!node || !node.parentNode) return;
    node.parentNode.removeChild(node);
  });
};

const startNavigatorPanelResize = () => {
  let cleanupResize = null;
  return {
    init: () => {
      cleanupResize?.();
      cleanupResize = initDwpNavigatorPanelResize();
    },
    destroy: () => {
      cleanupResize?.();
      cleanupResize = null;
    },
  };
};

const DwpEmployeeNavigatorLoader = ({ shouldLoad }) => {
  useEffect(() => {
    const panelResize = startNavigatorPanelResize();

    const teardown = () => {
      panelResize.destroy();
      removeDwpNavigatorArtifacts();
    };

    if (!shouldLoad) {
      teardown();
      return undefined;
    }

    // const existingScript = document.getElementById(DWP_SCRIPT_ID);
    // if (existingScript) {
    //   if (!registerDwpJwtGenerator()) {
    //     existingScript.addEventListener('load', () => {
    //       registerDwpJwtGenerator();
    //     }, { once: true });
    //   }
    const existingScript = document.getElementById(DWP_SCRIPT_ID);
    if (existingScript) {
      panelResize.init();
      return teardown;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.src = DWP_SCRIPT_URL;
    script.type = 'text/javascript';
    script.id = DWP_SCRIPT_ID;
    script.setAttribute('data-productName', 'Tech Central Agent');
    // script.setAttribute('data-rsso-server', RSSO_SERVER_URL);

    script.onload = () => {
      // registerDwpJwtGenerator();
      panelResize.init();
    };

    // script.onerror = () => {
    //   console.error('[DWP Navigator] Failed to load navigator trigger script:', DWP_SCRIPT_URL);
    // };

    document.body.appendChild(script);

    return teardown;
  }, [shouldLoad]);

  return null;
};

export default DwpEmployeeNavigatorLoader;
